import CustomerInfoForm from '../components/CustomerInfoForm/CustomerInfoForm'
import WindowSizeProvider from '../providers/WindowSizeProvider'
import { TileWrapper } from '../components/TileWrapper'

function CustomerInfoTile() {
  return (
    <TileWrapper>
      <WindowSizeProvider>
        <CustomerInfoForm />
      </WindowSizeProvider>
    </TileWrapper>
  )
}

export default CustomerInfoTile
